import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '../../../services/local/platform/platform.service';

@Component({
    standalone: true,
    template: '',
})
export abstract class ModalBaseComponent {
    protected modalCtrl = inject(ModalController);
    protected platform = inject(PlatformService);

    isMobile(): boolean {
        return this.platform.isMobile();
    }

    close() {
        this.modalCtrl.dismiss();
    }
}
